import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { PlainTooltip, Badge } from "@similarweb/ui-components";
import classNames from "classnames";
import React from "react";
import styled from "styled-components";

const CellIconComponent = styled(SWReactIcons).attrs(() => ({
    size: "sm",
}))`
    margin-right: 6px;
    path {
        fill: ${colorsPalettes.carbon["200"]};
    }
`;

const Wrapper = styled.span`
    margin-left: 5px;
`;

export class MetricIconCell extends React.Component<any, any> {
    public render() {
        const { value } = this.props,
            realValue = value["value"],
            icon = value["icon"],
            isBeta = value["isBeta"],
            tooltip = value["tooltip"],
            classes = classNames("u-flex-row value u-truncate");

        return (
            <div className="headerCell headerCell-leader u-truncate">
                <span className={classes}>
                    <CellIconComponent iconName={icon} />
                    {tooltip ? (
                        <PlainTooltip
                            placement="top"
                            tooltipContent={tooltip}
                        >
                            <span>{realValue}</span>
                        </PlainTooltip>
                    ) : (
                        <span>{realValue}</span>
                    )}
                    {isBeta ? (
                        <Wrapper>
                            <Badge type="beta" />
                        </Wrapper>
                    ) : null}
                </span>
            </div>
        );
    }
}
